if (!customElements.get('bestsellers-section')) {
  customElements.define(
    'bestsellers-section',
    class BestsellersSection extends HTMLElement {
      connectedCallback() {
        this.tabs = this.querySelectorAll('[data-bestsellers-tab]');
        this.panels = this.querySelectorAll('[data-bestsellers-panel]');

        if (!this.tabs.length || !this.panels.length) return;

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activateTab(tab));
        });

        if (typeof window.initBestsellersSliderDots === 'function') {
          const initDots = () => window.initBestsellersSliderDots(this);
          requestAnimationFrame(initDots);
          setTimeout(initDots, 150);
        }

        if (window.DEFWishlist && typeof window.DEFWishlist.initFavButtons === 'function') {
          window.DEFWishlist.initFavButtons(this);
        }
      }

      activateTab(tab) {
        const panelId = tab.dataset.bestsellersTab;
        if (!panelId) return;

        this.tabs.forEach((item) => {
          const isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        this.panels.forEach((panel) => {
          const isActive = panel.dataset.bestsellersPanel === panelId;
          panel.classList.toggle('is-active', isActive);
          panel.toggleAttribute('hidden', !isActive);
        });

        const activePanel = this.querySelector(`[data-bestsellers-panel="${panelId}"]:not([hidden])`);
        const slider = activePanel?.querySelector('slider-component');
        const track = activePanel?.querySelector('[id^="Slider-"]');
        if (track) track.scrollLeft = 0;
        if (slider && typeof slider.resetPages === 'function') {
          slider.resetPages();
        }

        if (typeof window.initBestsellersSliderDots === 'function') {
          activePanel?.querySelectorAll('.product-slider-dots[data-slider-dots]').forEach((dotsWrap) => {
            delete dotsWrap.dataset.dotsInitialized;
          });
          window.initBestsellersSliderDots(activePanel);
        }

        if (window.DEFWishlist && typeof window.DEFWishlist.initFavButtons === 'function') {
          window.DEFWishlist.initFavButtons(activePanel);
        }
      }
    }
  );
}
